import Button from "Components/Button";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-cropper";
import { connect } from "react-redux";
import { FormError } from "Themes/StyledComponents";
import LoadingIcon from "Components/LoadingIcon";

const styles = {
  modal: {
    maxWidth: "100%",
  }
}

class CropImageModal extends Component {
  constructor(props) {
    super(props);
    this.cropFileInput = React.createRef();
  }

  handleSubmit = e => {
    e.preventDefault();
    const img = this.refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
    this.props.handleSubmit(img);
  };

  render() {
    const { show, onHide, detail, error, fetching } = this.props;
    return (
      <Modal show={show} onHide={onHide} style={styles.modal}>
        <Modal.Header closeButton>Crop your Image</Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <Cropper
              ref="cropper"
              src={detail}
              style={{
                margin: "auto",
                marginTop: "25px",
                height: 400,
                width: "100%",
                backgroundColor: "rgba(255, 255, 255)"
              }}
              // Cropper.js options
              aspectRatio={9 / 9}
              guides={false}
              background={false}
              viewMode={3}
              dragMode={"move"}
            />
          </Modal.Body>
          <Modal.Footer style={{ display: 'flex', flexDirection: 'column' }}>
            <Button type={"submit"}>{ fetching ? <LoadingIcon /> : "Crop"}</Button>
            {error && <FormError>{error}</FormError>}
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CropImageModal);
